import * as types from "../../store/mutation-types";
// import axios from "axios";
// import { API } from "../../mixins/constants";
import { getCovidTests, createUpdateCovidTests } from "../../store/api/api";

const state = {
  test_covid_19_info: [],
  covid_test: {},
  create_success: false
};
const getters = {};
const actions = {
  async getListCovidTest({ commit }, data){
    return new Promise((resolve, reject) => {
      getCovidTests(data).then(response => {
        if (response) {
          commit(types.GET_LIST_COVID_TEST, response.data);
          resolve(response);
        } else {
          reject(response);
        }
      })
      .catch(err => {
        reject(err.response);
      });
    });
  },
  async createUpdateCovidTest({ commit }, data){
    return new Promise((resolve, reject) => {
      createUpdateCovidTests(data).then(response => {
        if (response) {
          commit(types.CREATE_COVID_TEST);
          resolve(response);
        } else {
          reject(response);
        }
      })
      .catch(err => {
        resolve(err.response);
      });
    });
  },
  getItemCovidTest({ commit }, data){
    commit(types.GET_COVID_TEST_ITEM, data);
  }
};
const mutations = {
  [types.GET_LIST_COVID_TEST](state, data) {
    state.test_covid_19_info = data;
  },
  [types.CREATE_COVID_TEST](state) {
    state.create_success = true;
  },
  [types.GET_COVID_TEST_ITEM](state, data) {
    state.covid_test = data;
    state.create_success = false
  },
};

export default {
  state,
  mutations,
  actions,
  getters
};
